export default "-- RTABench Q6\nSELECT * FROM order_events \nWHERE backup_processor <> '' ORDER BY event_created LIMIT 10;\n";